'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Field as FieldComponent } from '../field/index.js';
import { Input } from '../input/input.js';
import { Label } from '../label/label.js';
import { ValidationMessage } from '../validation-message/validation-message.js';

/**
 * Radio used to select multiple options.
 *
 * @example
 * <Radio label="I agree" value="agree" />
 */
const Radio = forwardRef(function Radio({ 'data-size': size, className, style, children, label, description, error, ...rest }, ref) {
    return (jsxs(FieldComponent, { "data-size": size, className: className, style: style, children: [jsx(Input, { type: 'radio', ref: ref, ...rest }), !!label && jsx(Label, { weight: 'regular', children: label }), !!description && jsx("div", { "data-field": 'description', children: description }), !!error && jsx(ValidationMessage, { children: error })] }));
});

export { Radio };
